import React, { useState } from "react";
import { Box, Grid, TextField, FormControl, Button, Modal, TableCell, TableBody, TableContainer, TableHead, TableRow, Table, Typography } from "@mui/material";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  height: "max-content",
  overflowY: "scroll",
  p: 2,
};

const Tickets = () => {
  const [openModal, setOpenModal] = useState(false);
  const [newTicket, setNewTicket] = useState({ subject: "", assigned: "" });
  const [ticketData, setTicketData] = useState([
    { id: 1, ticketId: "TCK123", subject: "Development Task", assigned: "Dev", createdat: "13/02/25", status: "Completed" },
    { id: 2, ticketId: "TCK124", subject: "Design Review", assigned: "Vinay", createdat: "13/02/25", status: "In Progress" },
    { id: 3, ticketId: "TCK125", subject: "Design Review", assigned: "Vinay", createdat: "13/02/25", status: "In Progress" },
    { id: 4, ticketId: "TCK126", subject: "Design Review", assigned: "Vinay", createdat: "13/02/25", status: "In Progress" },
    { id: 5, ticketId: "TCK127", subject: "Design Review", assigned: "Vinay", createdat: "13/02/25", status: "In Progress" },
  ]);

  const [request, setRequest] = useState(false);

  // Open and Close Modal functions
  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);

  // Handle input change
  const handleFieldChange = (e) => {
    setNewTicket({ ...newTicket, [e.target.name]: e.target.value });
  };
  const getStatusButtonColor = (status) => {
    switch (status) {
      case "Completed":
        return { backgroundColor: "#4caf50", color: "white" };
      case "In Progress":
        return { backgroundColor: "#ff9800", color: "white" };
      case "Not Started":
        return { backgroundColor: "#f44336", color: "white" };
      default:
        return { backgroundColor: "#e0e0e0", color: "black" };
    }
  };

  // Handle the Add Ticket submission
  const handleAddTicket = (event) => {
    event.preventDefault();
    const newTicketData = {
      id: ticketData.length + 1, // This will add the new ticket with a unique ID
      ticketId: `TCK${(ticketData.length + 1).toString().padStart(3, '0')}`,
      subject: newTicket.subject,
      assigned: newTicket.assigned,
      createdat: new Date().toLocaleDateString(),
      status: "Not Started",
    };

    setTicketData([...ticketData, newTicketData]);
    setRequest(false); // Reset request state (if you were showing a loading spinner)
    handleModalClose(); // Close the modal
    setNewTicket({ subject: "", assigned: "" }); // Reset form fields
  };

  return (
    <Box sx={{ p: 4 }}>
      {/* Heading and Add Ticket Button */}
       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#000" }}>
          Tickets
        </Typography>
        <Button
  variant="contained"
  color="primary"
  sx={{
    backgroundColor: "#2F3B57",
    display: "flex",
    alignItems: "center",
    gap: 1, // Adjust the gap between the icon and the text
  }}
  onClick={handleModalOpen}
>
  <AddCircleOutlineOutlinedIcon sx={{ marginRight: 1 }} /> Add Ticket
</Button>
      </Box>

      {/* Ticket Table */}
      <Box sx={{ mt: 4 }}>
        <TableContainer >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Ticket ID</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Subject</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Assigned</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Created At</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "black" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ticketData.map((ticket) => (
                <TableRow key={ticket.id}>
                  <TableCell>{ticket.ticketId}</TableCell>
                  <TableCell>{ticket.subject}</TableCell>
                  <TableCell>{ticket.assigned}</TableCell>
                  <TableCell>{ticket.createdat}</TableCell>
                  <TableCell>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: getStatusButtonColor(ticket.status).backgroundColor,
                      color: getStatusButtonColor(ticket.status).color,
                      borderRadius: "5px",
                      padding: "5px 10px",
                      textTransform: "none", // Keep text as is, no uppercase
                    }}
                  >
                    {ticket.status}
                  </Button>
                </TableCell>
                                    <TableCell>
                  {/* Action Buttons */}
                  <EditIcon sx={{ color: "green", mr: 1 }} />
                  <DeleteIcon sx={{ color: "red" }} />
                </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Modal for Adding Ticket */}
      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="sm_modal">
          {/* Modal Header */}
          <ModalHeader title="Add New Ticket" handleClose={handleModalClose} />

          {/* Form for Adding Ticket */}
          <Box
            component="form"
            id="addTicket"
            validate
            autoComplete="off"
            onSubmit={handleAddTicket}
            sx={{ "& .MuiTextField-root": { m: 2 } }}
          >
            <Grid container sx={{ pt: 1, display: "flex", justifyContent: "center" }}>
              <Grid item md={10} xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Subject"
                    name="subject"
                    size="small"
                    value={newTicket.subject}
                    required
                    onChange={handleFieldChange}
                    fullWidth
                  />
                </FormControl>
              </Grid>

              <Grid item md={10} xs={12}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label="Assigned To"
                    name="assigned"
                    size="small"
                    value={newTicket.assigned}
                    required
                    onChange={handleFieldChange}
                    fullWidth
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Modal Footer */}
          <ModalFooter
            form="addTicket"
            request={request}
            btn="Add Ticket"
            disable={!newTicket.subject || !newTicket.assigned}
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default Tickets;
